import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import ConsTypeDonationDocument from './cons-type-donation-document';
import ConsTypeDonationDocumentDetail from './cons-type-donation-document-detail';
import ConsTypeDonationDocumentUpdate from './cons-type-donation-document-update';
import ConsTypeDonationDocumentDeleteDialog from './cons-type-donation-document-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={ConsTypeDonationDocumentUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={ConsTypeDonationDocumentUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={ConsTypeDonationDocumentDetail} />
      <ErrorBoundaryRoute path={match.url} component={ConsTypeDonationDocument} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={ConsTypeDonationDocumentDeleteDialog} />
  </>
);

export default Routes;
